import { Subject } from 'rxjs'
import { Injectable } from '@angular/core'

export type KeyValue = { key: string; value: any }

@Injectable({ providedIn: 'root' })
export class BaseStorageService {
  private subjectMap: Map<string, Subject<KeyValue>> = new Map()

  get(key: string) {
    return localStorage.getItem(key)
  }

  set(key: string, value: string) {
    localStorage.setItem(key, value)
    this.observe(key, { key, value })
  }

  remove(key: string) {
    localStorage.removeItem(key)
  }

  subscribe(key: string, sub: (next: KeyValue) => {}) {
    let subject = this.subjectMap.get(key)

    if (!subject) {
      subject = new Subject()
      this.subjectMap.set(key, subject)
    }

    return subject.subscribe(sub)
  }

  observe(key: string, value: KeyValue) {
    this.subjectMap.get(key)?.next(value)
  }
}
